import { TutorialProps } from '@/services/tutorialService/tutorialTypes';
import { useLocalization } from '@/services/localizationService';

export const useNewModelsTutorial = () => {
  const tutorialId = 'tutorial-new-models';

  const { data } = useLocalization();

  const newModelsTutorialSteps: TutorialProps['steps'] = [
    {
      id: 'different-styles',
      description: data.result.tutorialAiModelsStepOne,
      index: 1,
      position: 'right',
    },
    {
      id: 'color-profile',
      description: data.result.tutorialAiModelsStepTwo,
      index: 2,
      position: 'right',
    },
    {
      id: 'apply',
      description: data.result.tutorialAiModelsStepThree,
      index: 3,
      position: 'right',
    },
  ];

  return {
    newModelsTutorialId: tutorialId,
    newModelsTutorialSteps,
  };
};
